const CHATWOOT_SCRIPT_SELECTOR = "script[data-brokerkit-chatwoot]";
const CHATWOOT_INITIALIZED_FLAG = "__brokerkitChatwootInitialized";

const initializeChatwoot = ({ baseUrl, websiteToken } = {}) => {
  if (!baseUrl || !websiteToken || window[CHATWOOT_INITIALIZED_FLAG]) {
    return false;
  }

  const normalizedBaseUrl = baseUrl.replace(/\/$/, "");
  const scriptUrl = `${normalizedBaseUrl}/packs/js/sdk.js`;
  const initializeSdk = () => {
    if (window[CHATWOOT_INITIALIZED_FLAG] || !window.chatwootSDK?.run) {
      return;
    }

    window.chatwootSDK.run({
      websiteToken,
      baseUrl: normalizedBaseUrl,
    });
    window[CHATWOOT_INITIALIZED_FLAG] = true;
  };

  window.chatwootSettings = {
    ...window.chatwootSettings,
    position: "left",
  };

  if (window.chatwootSDK?.run) {
    initializeSdk();
    return true;
  }

  const existingScript = Array.from(document.scripts).find(
    (script) =>
      script.src === scriptUrl || script.matches(CHATWOOT_SCRIPT_SELECTOR),
  );
  if (existingScript) {
    if (existingScript.matches(CHATWOOT_SCRIPT_SELECTOR)) {
      existingScript.addEventListener("load", initializeSdk, { once: true });
    }
    return true;
  }

  const script = document.createElement("script");
  script.async = true;
  script.dataset.brokerkitChatwoot = "true";
  script.src = `${normalizedBaseUrl}/packs/js/sdk.js`;
  script.addEventListener("load", initializeSdk, { once: true });
  document.head.appendChild(script);

  return true;
};

export default initializeChatwoot;
